import { h } from "@stencil/core";
/**
 * A link action.
 * @slot - The label for the action, applied to the link, or shown in a dropdown.
 */
export class ESActionLink {
    constructor() {
        this.dropdownItem = false;
        this.url = undefined;
        this.disabled = false;
        this.icon = undefined;
        this.dot = undefined;
    }
    render() {
        return (h("es-button-link", { key: 'eb294b8307b98c5c85d5950eac97926441a051d4', url: this.url, variant: 'minimal', disabled: this.disabled, title: this.host.textContent ?? undefined }, h("es-badge", { key: 'e18459aba20213b9e1ba70c8de9e3da1582d174a', variant: 'dot', color: this.dot, count: this.dot ? 1 : 0, slot: this.dropdownItem ? 'before' : undefined }, h("es-icon", { key: 'fa0adcccd34e7f0ce29a22198272e8a8ea57f672', icon: this.icon, size: 20 })), this.dropdownItem && h("slot", { key: '1b9faf9e5cc4e983d35c975e649b70c9f57f0758' })));
    }
    static get is() { return "es-action-link"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get properties() {
        return {
            "dropdownItem": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the action is within an `es-action-dropdown`."
                },
                "attribute": "dropdown-item",
                "reflect": true,
                "defaultValue": "false"
            },
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The url to go to when clicked."
                },
                "attribute": "url",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the action should be disabled."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconDescription",
                    "resolved": "[namespace: string | symbol, name: string] | string",
                    "references": {
                        "IconDescription": {
                            "location": "import",
                            "path": "../../es-icon/types",
                            "id": "src/components/es-icon/types.ts::IconDescription"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon to show for the action."
                },
                "attribute": "icon",
                "reflect": false
            },
            "dot": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "HTMLEsBadgeElement['color']",
                    "resolved": "\"error\" | \"okay\" | \"warning\" | undefined",
                    "references": {
                        "HTMLEsBadgeElement": {
                            "location": "global",
                            "id": "global::HTMLEsBadgeElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If a dot should be shown on the action, to indicate attention being required."
                },
                "attribute": "dot",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-action-link.js.map
